import { requestAsync, httpMethods } from 'redux-query';
import cfg from 'cfg';

export const createTrigger = value => {
    const url = `${cfg.triggerer.host}/api/triggers`;
    const config = {
        body: value,
        url,
        queryKey: 'trigger',
        key: 'trigger',
        force: true,
        transform: response => {
            return {};
        },
        update: {},
        options: {
            method: httpMethods.POST
        }
    };
    return requestAsync(config);
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/actions/trigger.js
 **/